// @flow
import {
  UPDATE_PERSONALIZATION_FAILURE,
  UPDATE_PERSONALIZATION_REQUEST,
  UPDATE_PERSONALIZATION_SUCCESS,
  GET_PERSONALIZATION_FAILURE,
  GET_PERSONALIZATION_REQUEST,
  GET_PERSONALIZATION_SUCCESS,
  PersonalizationAction,
  PersonalizationState
} from 'stores/flow-type/personalization.type';

const initialState: PersonalizationState = {
  updating: false,
  loading: false,
  success: false,
  settings: {}
};

const PersonalizationReducers = (
  state: PersonalizationState = initialState,
  action: PersonalizationAction
) => {
  switch (action.type) {
    // Get product performance ranking
    case GET_PERSONALIZATION_REQUEST:
      return { ...state, loading: true };
    case GET_PERSONALIZATION_SUCCESS: {
      return {
        ...state,
        loading: false,
        settings: action.payload.data || {},
        error: undefined
      };
    }
    case GET_PERSONALIZATION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    // Update product performance ranking
    case UPDATE_PERSONALIZATION_REQUEST:
      return { ...state, updating: true, success: false };
    case UPDATE_PERSONALIZATION_SUCCESS: {
      return {
        ...state,
        updating: false,
        success: true,
        settings: action.payload.data || {},
        error: undefined
      };
    }
    case UPDATE_PERSONALIZATION_FAILURE:
      return {
        ...state,
        updating: false,
        success: false,
        error: action.payload
      };
    default:
      return state;
  }
};
export default PersonalizationReducers;
